import React, { } from "react";
import LocationPic from "./LocationPic";
import LocationInfo from "./LocationInfo";
import './index.scss';

const LocationItem = ({ item, _editItem, _deleteAndRestore, _viewInfo }) => {
    return (
        <>
            <div className="location-item d-flex position-relative">
                <LocationPic info={item} _editItem={_editItem} _deleteAndRestore={_deleteAndRestore} _viewInfo={_viewInfo} />
                <LocationInfo info={item} />
            </div>
        </>
    )
};
export default LocationItem;